import React from "react";
import { Form, Schema } from "rsuite";
import styled from "styled-components";

import FormHOC from "hoc/FilltersForm";
import CustomField from "components/Form/CustomField";
import InputSearch from "components/Form/InputSearch";

const { StringType } = Schema.Types;

const filtersModel = Schema.Model({
    str: StringType().maxLength(40, "The maximum is only 40 characters."),
});


const RangeFilters = ({ onChange, onUpdateRef }) => {
    return (
        <>
            <StyledForm
                layout="inline"
                onChange={onChange}
                ref={ref => onUpdateRef(ref)}
                // formDefaultValue={
                model={filtersModel}
            >
                <CustomField
                    name="str"
                    accepter={InputSearch}
                    errorPlacement="topRight"
                    placeholder="Range name/Numbers search"
                    style={{ width: 220 }}
                />
                {/* {!service && <CustomField
                    name="mcc_mnc"
                    placeholder="MCC MNC"
                />} */}
            </StyledForm>
        </>
    );
};

export default FormHOC(RangeFilters, filtersModel, 800);

const StyledForm = styled(Form)`
    && {
        margin-bottom: 0px !important;

        .rs-form-group {
            margin-bottom: 0px !important;
        }
    }
`;
